// extracted by mini-css-extract-plugin
export default {"actionIcons":"SpecialRequestCommentsPanel_actionIcons__FegDs"};